export default __webpack_public_path__ + "1d44b26c6604faabebe46e302ead1a58.png";